type GtmWindow = Window & {
    dataLayer?: Record<string, unknown>[]
}

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/

export default defineNuxtPlugin(() => {
    const { public: publicConfig } = useRuntimeConfig()
    const gtmId = String(publicConfig.gtmId || '')

    if (publicConfig.appEnv !== 'production' || !GTM_ID_PATTERN.test(gtmId)) {
        return
    }

    const googleWindow = window as GtmWindow
    const dataLayer = googleWindow.dataLayer || []

    googleWindow.dataLayer = dataLayer

    if (!document.getElementById('gtm-script')) {
        dataLayer.push({
            ['gtm.start']: Date.now(),
            event: 'gtm.js',
        })

        useHead({
            script: [
                {
                    id: 'gtm-script',
                    src: `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`,
                    async: true,
                },
            ],
            // noscript fallback lives in app.vue (SSR-rendered, gated on gtmId)
        })
    }

    const router = useRouter()

    const trackPageView = (path: string) => {
        dataLayer.push({
            event: 'page_view',
            page_path: path,
            page_location: window.location.href,
            page_title: document.title,
        })
    }

    trackPageView(router.currentRoute.value.fullPath)
    router.afterEach(() => trackPageView(router.currentRoute.value.fullPath))
})
